import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Grid, Table, Icon, Image } from 'semantic-ui-react'
import moment from "moment";
import { useHistory, NavLink } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import { getOrders } from '../../store/OrderRedux'
import { useTranslation } from "react-i18next";
import { StarButton } from '../../components'

const MyorderScreen = (props) => {
  const dispatch = useDispatch()
  const history = useHistory();
  const token = useSelector((state) => state.auth.token)
  const orders = useSelector((state) => state.order.orders)
  const [order, setOrder] = useState([])
  const { t, i18n } = useTranslation();


  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getOrders({ token }))
  }, []);

  useEffect(() => {
    let newOrder = []
    for (let item of orders) {
      let total = 0
      let answers = 0
      if (item.contestant) {
        total = item.contestant.questionBank.length
        for (let subItem of item.contestant.questionBank) {
          if (subItem.correct === true) {
            answers = answers + 1
          }
        }
      }
      newOrder.push({
        ...item,
        total, answers
      })
    }
    setOrder(newOrder)
  }, [orders]);

  return (
    <div className="container">
      <div className="orders_pags">
        <h4>{t("myorder.titel")}</h4>
        <p> {t("myorder.para")}</p>
      </div>

      <div className="inner_bg destops">
        <div className="celebrity">
          <Table>
            <Table.Row>
              <Table.HeaderCell><h4>Contest ID </h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Date </h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Contest Name</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Celebrity</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Amount Paid</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Invoice</h4></Table.HeaderCell>
            </Table.Row>
          </Table>
        </div>
        <div className="text"></div>
        <div className="scrolls-y" style={{ height: 400 }}>
          {order.map((item, key) => <div key={key} className="amount">
            <Table>
              <Table.Row>
                <Table.HeaderCell><h4>#{item.code}</h4></Table.HeaderCell>
                <Table.HeaderCell><h4>{moment.utc(item.createdAt).format('Do MMM YYYY')}</h4></Table.HeaderCell>
                <Table.HeaderCell><h4>{item.triviaDescription} <Icon name='info circle' size='small' /></h4></Table.HeaderCell>
                <Table.HeaderCell><h4>{item.triviaName}</h4></Table.HeaderCell>
                <Table.HeaderCell><h4>₹ {item.entryFees}</h4></Table.HeaderCell>
                <Table.HeaderCell><a href="#">Download Invoice</a></Table.HeaderCell>
              </Table.Row>
            </Table>
          </div>)}
          <div className="text"></div>

        </div>
      </div>
      <div className="mobiles scrolls-y" style={{ height: 400 }}>
        {order.map((item, key) => <div key={key} className="sarukhu mobiles">
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <h4>{item.triviaDescription}</h4>
                <h5>{item.triviaName}</h5>
              </Grid.Column>
              <Grid.Column >
                <h6>#{item.code}</h6>
                <h6>{moment.utc(item.createdAt).format('Do MMM YYYY')}</h6>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className="answered">
            {item.total && (<h4>Your have answered <span>{item.answers} out of {item.total}</span> questions correctly !</h4>)}
          </div>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <h3><a onClick={() => {
                  history.push(`/rewards`)
                }}>View reward</a></h3>
              </Grid.Column>
              <Grid.Column>
                <h3><a href="#"> Download Invoice</a></h3>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>)}
      </div>
      <Grid centered columns={16} >
        <Grid.Row >

          <StarButton background={'mainBg'} width="350px" title={t("myorder.btn")} onClickAction={() => history.push('/')} />

        </Grid.Row>
      </Grid>

    </div>
  );
};

export default MyorderScreen